import { render, staticRenderFns } from "./FormModalClientes.vue?vue&type=template&id=f87c3788"
import script from "./FormModalClientes.vue?vue&type=script&lang=js"
export * from "./FormModalClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f87c3788')) {
      api.createRecord('f87c3788', component.options)
    } else {
      api.reload('f87c3788', component.options)
    }
    module.hot.accept("./FormModalClientes.vue?vue&type=template&id=f87c3788", function () {
      api.rerender('f87c3788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/cuenta/FormModalClientes.vue"
export default component.exports